angular.module('bmsApp.settings').factory('TableManagerSvc', function ($http, $log, $window, $q, CRUDSvc, TABLE_MANAGER_API) {

	return {
		index: function(params){return CRUDSvc.get(TABLE_MANAGER_API.INDEX, params);},
		update: function (data) {return CRUDSvc.post(TABLE_MANAGER_API.UPDATE, data);}
	}

}).constant('TABLE_MANAGER_API', {
  INDEX: 'api/settings/tableManager/index',
  UPDATE: 'api/settings/tableManager/update'
});


angular.module('bmsApp.settings').service('TableManagerObject', function () {
	this.newObject = {
		id: '',
		name: '',
		deleted: false
	}
});